export enum TextureType {
	Counter = 'Counter',
	Trim = 'Trim',
	Surround = 'Surround',
	Sky = 'Sky',
	Floor = 'Floor'
}

